module.exports = __webpack_public_path__ + "img/A95E4D_57261A_6E3223_773C24-256px.d289ad1a.png";